import axios from 'axios';

export const createUserCloseFile = async (fileId: number, reason?: string) => {
  const { data: res } = await axios.post('/user-close-files', { fileId, reason });
  return res;
};
export const deleteUserCloseFile = async (fileId: number) => {
  const { data: res } = await axios.delete(`/user-close-files/${fileId}`);
  return res;
};
export const getListUserCloseFile = async () => {
  const { data: res } = await axios.get('/user-close-files');
  return res;
};
